import React from "react";
import { Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
const ShowPlayOff = (props) => {
  return (
    <>
      <Modal
        show={props.isPlayOffModalOpen}
        onHide={() => props.setIsPlayOffModalOpen(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            H2H-Playoff 1 (
            {moment(props?.roundDetails.start_date).format("MMM D")}-
            {moment(props?.roundDetails.end_date).format("MMM D")})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="roundinfomodal"
            style={{ maxHeight: "400px", overflowY: "auto" }}
          >
            <div className="chain-cols" style={{ width: "300px" }}>
              <div className="rount-point">
                <span className="point-count">M1</span>
                {!props.playOffMatch1 && (
                  <ul className="tabslist">
                    <li>
                      {props.rankingData?.rank3Data?.fo_image && (
                        <img
                          src={`${process.env.REACT_APP_USER_PROFILE}/${props.rankingData?.rank3Data?.fo_image}`}
                          alt="img"
                        />
                      )}
                      {!props.rankingData?.rank3Data?.fo_image && (
                        <img src={`../images/user-img.png`} alt="img" />
                      )}
                      <span className="name-fs">
                        {props.rankingData?.rank3Data?.fm_name}
                      </span>{" "}
                    </li>
                    <li>
                      {props.rankingData?.rank6Data?.so_image && (
                        <img
                          src={`${process.env.REACT_APP_USER_PROFILE}/$props.rankingData?.rank6Data?.so_image}`}
                          alt="img"
                        />
                      )}
                      {!props.rankingData?.rank6Data?.so_image && (
                        <img src={`../images/user-img.png`} alt="img" />
                      )}
                      <span className="name-fs">
                        {props.rankingData?.rank6Data?.fm_name}
                      </span>{" "}
                    </li>
                  </ul>
                )}
                {props.playOffMatch1 && (
                  <ul className="tabslist">
                    <li>
                      {props.playOffMatch1?.fo_image && (
                        <img
                          src={`${process.env.REACT_APP_USER_PROFILE}/${props.playOffMatch1?.fo_image}`}
                          alt="img"
                        />
                      )}
                      {!props.playOffMatch1?.fo_image && (
                        <img src={`../images/user-img.png`} alt="img" />
                      )}
                      <span className="name-fs">
                        {props.playOffMatch1?.fm_name}
                      </span>
                      {props.playOffMatch1.total_points_first_member >
                      props.playOffMatch1.total_points_second_member ? (
                        <span className="rankcount winnerPlayer">
                          {props.playOffMatch1.total_points_first_member}
                        </span>
                      ) : (
                        <span className="rankcount orange">
                          {props.playOffMatch1.total_points_first_member}
                        </span>
                      )}
                    </li>
                    <li>
                      {props.playOffMatch1?.sm_image && (
                        <img
                          src={`${process.env.REACT_APP_USER_PROFILE}/$props.playOffMatch1?.sm_image}`}
                          alt="img"
                        />
                      )}
                      {!props.playOffMatch1?.sm_image && (
                        <img src={`../images/user-img.png`} alt="img" />
                      )}
                      <span className="name-fs">
                        {props.playOffMatch1?.sm_name}
                      </span>
                      {props.playOffMatch1.total_points_second_member >
                      props.playOffMatch1.total_points_first_member ? (
                        <span className="rankcount winnerPlayer">
                          {props.playOffMatch1.total_points_second_member}
                        </span>
                      ) : (
                        <span className="rankcount orange">
                          {props.playOffMatch1.total_points_second_member}
                        </span>
                      )}
                    </li>
                  </ul>
                )}
                <span className="point-count">M2</span>
                {!props.playOffMatch2 && (
                  <ul className="tabslist">
                    <li>
                      {props.rankingData?.rank4Data?.fo_image && (
                        <img
                          src={`${process.env.REACT_APP_USER_PROFILE}/${props.rankingData?.rank4Data?.fo_image}`}
                          alt="img"
                        />
                      )}
                      {!props.rankingData?.rank4Data?.fo_image && (
                        <img src={`../images/user-img.png`} alt="img" />
                      )}
                      <span className="name-fs">
                        {props.rankingData?.rank4Data?.fm_name}
                      </span>{" "}
                    </li>
                    <li>
                      {props.rankingData?.rank5Data?.so_image && (
                        <img
                          src={`${process.env.REACT_APP_USER_PROFILE}/$props.rankingData?.rank5Data?.so_image}`}
                          alt="img"
                        />
                      )}
                      {!props.rankingData?.rank5Data?.so_image && (
                        <img src={`../images/user-img.png`} alt="img" />
                      )}
                      <span className="name-fs">
                        {props.rankingData?.rank5Data?.fm_name}
                      </span>{" "}
                    </li>
                  </ul>
                )}

                {props.playOffMatch2 && (
                  <ul className="tabslist">
                    <li>
                      {props.playOffMatch2?.fo_image && (
                        <img
                          src={`${process.env.REACT_APP_USER_PROFILE}/${props.playOffMatch2?.fo_image}`}
                          alt="img"
                        />
                      )}
                      {!props.playOffMatch2?.fo_image && (
                        <img src={`../images/user-img.png`} alt="img" />
                      )}
                      <span className="name-fs">
                        {props.playOffMatch2?.fm_name}
                      </span>
                      {props.playOffMatch2.total_points_first_member >
                      props.playOffMatch2.total_points_second_member ? (
                        <span className="rankcount winnerPlayer">
                          {props.playOffMatch2.total_points_first_member}
                        </span>
                      ) : (
                        <span className="rankcount orange">
                          {props.playOffMatch2.total_points_first_member}
                        </span>
                      )}
                    </li>
                    <li>
                      {props.playOffMatch2?.sm_image && (
                        <img
                          src={`${process.env.REACT_APP_USER_PROFILE}/$props.playOffMatch2?.sm_image}`}
                          alt="img"
                        />
                      )}
                      {!props.playOffMatch2?.sm_image && (
                        <img src={`../images/user-img.png`} alt="img" />
                      )}
                      <span className="name-fs">
                        {props.playOffMatch2?.sm_name}
                      </span>
                      {props.playOffMatch2.total_points_second_member >
                      props.playOffMatch2.total_points_first_member ? (
                        <span className="rankcount winnerPlayer">
                          {props.playOffMatch2.total_points_second_member}
                        </span>
                      ) : (
                        <span className="rankcount orange">
                          {props.playOffMatch2.total_points_second_member}
                        </span>
                      )}
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="poweredby">
            Powered By
            <img src="images/logo.png" alt="img" />
          </div>

          <div className="">
            <Link
              className="border-btn"
              onClick={() => props.setIsPlayOffModalOpen(false)}
            >
              Close
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ShowPlayOff;
